import { Button, Checkbox, Flex, Form } from "antd";
import { CheckboxProps } from "antd/lib";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import iconAssist from "../../../assets/images/booking/icon-assist.svg";
import IcMoveToast from "../../../assets/images/diagram/ic-move-toast.svg";
import "../../../assets/styles/desktop/busBooking.scss";
import Loader from "../../../components/layouts/Loader";
import ModalAlertBalance from "../../../components/Modal/ModalAlertBalance";
import ModalAlertBalanceAgent from "../../../components/Modal/ModalAlertBalanceAgent";
import { Constant, Toast, YearFormat } from "../../../config/constant";
import { Action, CANCEL_TICKET_SUCCESS } from "../../../config/message";
import { convertTimeFormat, isWaitingBooking } from "../../../lib/utils";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  resetReloadDetail,
  selectAuth,
  setReloadDetail,
} from "../../../redux/slice/authSlice";
import {
  checkBookingSelector,
  getCheckBookingV2,
  resetCheckBookingSegment,
} from "../../../redux/slice/bookings/checkBookingSlice";
import {
  createBookingSelector,
  filterBookingCustomer,
  resetBooking,
  resetPriceBooking,
  setBookingForAgentId,
} from "../../../redux/slice/bookings/createBookingSlice";
import {
  destroyBooking,
  destroyBookingSelector,
  resetDestroyBooking,
} from "../../../redux/slice/bookings/destroyBookingSlice";
import {
  getAssistBookingSelector,
  resetAssistBooking,
} from "../../../redux/slice/bookings/getAssistBookingSlice";
import {
  holdingBookingSelector,
  postHoldingTicketV2,
  resetHoldingBooking,
} from "../../../redux/slice/bookings/holdingBookingSlice";
import {
  getListCustomerBooking,
  listBookingSelector,
  resetDataMoveTicket,
  setDetectLoading,
  setIsShowAllFloor,
} from "../../../redux/slice/bookings/listBooking";
import {
  getBookingRenderV2,
  listBookingRenderSelector,
  setIsShowNewBooking,
} from "../../../redux/slice/bookings/listBookingRender";
import {
  getBookingDetailSeat,
  getListBookingDetail,
  listDetailTicketSelector,
  resetListBookingDetail,
  resetListBookingTicket,
} from "../../../redux/slice/bookings/listDetailTicketSlice";
import {
  moveTicketSelector,
  resetListAvailableSeat,
  resetMoveTicket,
  setIsMoveTicketWaiting,
} from "../../../redux/slice/bookings/moveTicketSlice";
import { printTicketSelector } from "../../../redux/slice/bookings/printTicketSlice";
import {
  getSendBookingMail,
  resetUpdateBooking,
  updateBookingSelector,
  updateStatusBooking,
} from "../../../redux/slice/bookings/updateBooking";
import { resetDriverBooking } from "../../../redux/slice/bookings/updateDriverSlice";
import { setToast } from "../../../redux/slice/toastNotifySlice";
import ModalChangeBooking from "../changeBooking/ModalChangeBooking";
import ModalBooking from "../ModalBooking";
import ModalBookingDetail from "../ModalBookingDetail";
import ModalMultiBooking from "../ModalMultiBooking";
import ModalPrintTicket from "../tickets/ModalPrintTicket";
import BusDiagramBookingRender from "./BusDiagramBookingRender";
import ListCustomerNoDiagram from "./ListCustomerNoDiagram";
import ListTicketCancel from "./ListTicketCancel";
import {
  moveBookingSelector,
  resetPostMoveBooking,
} from "../../../redux/slice/bookings/bookingTicketSlice";

function BusDiagram({
  listBooking,
  formSearch,
  openDetailScheduleBooking,
  isContract,
  statusFloor,
  setStatusFloor,
  refs,
}: any) {
  const { status: statusResponseUpdate, loadingSend } = useAppSelector(
    updateBookingSelector
  );
  const { dataBooking } = useAppSelector(holdingBookingSelector);
  const { listDataSegmentBooking, status: statusCheckBooking } =
    useAppSelector(checkBookingSelector);
  const { status: statusDestroy } = useAppSelector(destroyBookingSelector);
  const { status: statusHolding, bookingType } = useAppSelector(
    holdingBookingSelector
  );
  const { isPrintTicket } = useAppSelector(printTicketSelector);
  const {
    loading: loadingDetail,
    bookingData,
    isShowAllFloor,
    isMoveTicket,
  } = useAppSelector(listBookingSelector);
  const { listBookingDetail, listBookingDetailSeat, seat_number } =
    useAppSelector(listDetailTicketSelector);
  const {
    listBookingRender,
    isShowNewBooking,
    loading: loadingBookingRender,
  } = useAppSelector(listBookingRenderSelector);
  const { isMoveTicket: isMoveTicketWaiting, dataMoveTicket } =
    useAppSelector(moveTicketSelector);
  const { listFreeSeat, listAssistBooking, segmentSelected } = useAppSelector(
    getAssistBookingSelector
  );
  const { message, status: statusCreateUpdate } = useAppSelector(
    createBookingSelector
  );
  const { group } = useAppSelector(selectAuth);
  const {
    status: statusMoveTicket,
    statusUpdateLocation,
    loading: loadingMoveTicket,
  } = useAppSelector(moveTicketSelector);
  const { loading, statusMove } = useAppSelector(moveBookingSelector);

  const dispatch = useAppDispatch();
  const [openCreate, setOpenCreate] = useState(false);
  const [targetTime, setTargetTime] = useState(0);
  const [targetTicket, setTargetTicket] = useState<any>();
  const [openModalMulti, setOpenModalMulti] = useState(false);
  const [openModalBookingDetail, setOpenModalBookingDetail] = useState(false);
  const [busTypeData, setBusTypeData] = useState<any>();
  const [isMulti, setIsMulti] = useState(false);
  const [isDetail, setIsDetail] = useState(false);
  const [timeManage, setTimeManage]: any = useState<any>([]);
  const [openModalChangeBooking, setOpenModalChangeBooking] = useState(false);
  const [isChangeTicket, setIsChangeTicket] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const [openModalAlert, setOpenModalAlert] = useState(false);
  const [openModalAlertAgent, setOpenModalAlertAgent] = useState(false);
  const [showAllFLoor, setShowAllFloor] = useState<boolean>(false);
  const [showNewBooking, setShowNewBooking] = useState<boolean>(true);
  const [dataPrint, setDataPrint] = useState();
  const [dataBookingList, setDataBookingList] = useState<any>([]);
  const [selectedSeatName, setSelectedSeatName] = useState<any>(undefined);
  const searchDateBooking = dayjs(
    Form.useWatch("date_booking", formSearch)
  ).format(YearFormat);
  const searchDepartTime = Form.useWatch("depart_time", formSearch);
  const provinceId = Form.useWatch("route_id", formSearch);
  const dateSelect = dayjs(Form.useWatch("date_booking", formSearch));
  const timeBooking = dayjs(
    `${listBooking?.schedule?.arrive_date}T${listBooking?.schedule?.arrive_time}`,
    "DD/MM/YYYYTHH:mm:ss"
  );
  const closeBefore = listBooking?.schedule?.close_before_time
    ? dayjs(`${listBooking?.schedule?.close_before_time}`)
    : null;
  const now = dayjs();
  const isBooking = timeBooking.isBefore(now);
  const isDepart = !isBooking && listBooking?.trip?.status === "departed";
  const selectedSeatsItem = busTypeData?.count_floor
    ? ["floor1", "floor2"].flatMap((floor) =>
        busTypeData?.[floor]?.flatMap((row: any) =>
          row.filter((seat: any) => seat.selected).map((seat: any) => seat.name)
        )
      )
    : [];

  const cancelModal = () => {
    setIsDetail(false);
    setOpenCreate(false);
    setIsMulti(false);
    dispatch(resetPriceBooking());
    // dispatch(resetCheckBookingSegment());
    dispatch(resetListBookingTicket());
    dispatch(setBookingForAgentId(undefined));
    dispatch(resetCheckBookingSegment());
  };

  const cancelModalBookingDetail = () => {
    setIsDetail(false);
    setOpenModalBookingDetail(false);
    setIsMulti(false);
    dispatch(resetPriceBooking());
    dispatch(resetListBookingDetail());
  };
  const cancelChangBookingModal = () => {
    setOpenModalChangeBooking(false);
    dispatch(resetListAvailableSeat());
    dispatch(resetMoveTicket());
    dispatch(resetDataMoveTicket());
  };
  const handleOkChangeBooking = () => {};

  const cancelModalMulti = () => {
    setOpenModalMulti(false);
  };
  const handleOkModalBooking = () => {};
  const handleOkModalBookingDetail = () => {};

  const handleLockBooking = (name: string) => {
    if (listBooking?.schedule?.id && name) {
      const lockBookingData = {
        schedule_id: listBooking.schedule.id,
        seat_number: [name],
        depart_date: searchDateBooking,
        status: 1,
      };
      dispatch(updateStatusBooking(lockBookingData));
    }
  };
  const handleUnLockBooking = (name: string) => {
    if (listBooking?.schedule?.id && name) {
      const lockBookingData = {
        schedule_id: listBooking.schedule.id,
        seat_number: [name],
        depart_date: searchDateBooking,
        status: 0,
      };
      dispatch(updateStatusBooking(lockBookingData));
    }
  };
  const onCancelSuccess = useCallback(() => {
    dispatch(resetDriverBooking());
    dispatch(resetDestroyBooking());
    dispatch(resetUpdateBooking());
    dispatch(resetBooking());
    dispatch(resetCheckBookingSegment());
    dispatch(
      getBookingRenderV2({
        route_id: provinceId,
        depart_date: searchDateBooking,
        depart_time: convertTimeFormat(searchDepartTime),
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, formSearch, provinceId, searchDateBooking, searchDepartTime]);

  const cancelModalPrint = () => {
    dispatch(resetReloadDetail());
    setOpenModalPrint(false);
    setDataPrint(undefined);
  };
  const cancelModalAlert = () => {
    setOpenModalAlert(false);
  };
  const cancelModalAlertAgent = () => {
    setOpenModalAlertAgent(false);
  };
  const handleModalPrint = (
    seatInfo: any,
    name: string,
    ticketCode: string
  ) => {
    dispatch(setReloadDetail());
    setDataPrint(seatInfo);
    setOpenModalPrint(true);
    dispatch(
      getListBookingDetail({ seat_number: name, ticket_code: ticketCode })
    );
  };

  const handleCreateBooking = (name: string, rowIndex: any, colIndex: any) => {
    dispatch(resetListBookingDetail());
    setIsMulti(false);
    // dispatch(resetAssistBooking());
    dispatch(filterBookingCustomer({}));
    if (bookingType !== "contract") {
      setOpenCreate(true);
    }
    // const createBookingData = {
    //   schedule_id: +listBooking?.schedule?.id,
    //   seat_number: name,
    //   hold_type: 'single',
    //   depart_date: searchDateBooking,
    // };
    setSelectedSeatName(name);
    const checkBookingData = {
      schedule_id: +listBooking?.schedule?.id,
      seat_number: [name],
      depart_date: searchDateBooking,
      is_diagram: true,
    };
    // dispatch(postHoldingTicketV2(createBookingData));
    dispatch(getCheckBookingV2(checkBookingData));
    if (targetTicket !== `${rowIndex}-${colIndex}-${searchDateBooking}`) {
      setTargetTicket(`${rowIndex}-${colIndex}`);
      setTargetTime(new Date().getTime() + 5 * 60 * 1000);
      return;
    }
    if (targetTime <= 0) setTargetTime(new Date().getTime() + 5 * 60 * 1000);
  };
  const handleCreateMultiBooking = (
    name: any,
    rowIndex: any,
    colIndex: any
  ) => {
    dispatch(resetListBookingDetail());
    setIsMulti(true);
    dispatch(filterBookingCustomer({}));
    if (bookingType !== "contract") {
      setOpenModalMulti(true);
    }
    setSelectedSeatName(name);
    const checkBookingData = {
      schedule_id: +listBooking?.schedule?.id,
      seat_number: name,
      depart_date: searchDateBooking,
      is_diagram: true,
    };
    dispatch(getCheckBookingV2(checkBookingData));
    if (targetTicket !== `${rowIndex}-${colIndex}-${searchDateBooking}`) {
      setTargetTicket(`${rowIndex}-${colIndex}`);
      setTargetTime(new Date().getTime() + 5 * 60 * 1000);
      return;
    }
    if (targetTime <= 0) setTargetTime(new Date().getTime() + 5 * 60 * 1000);
  };
  const handleLockMultiBooking = (name: any) => {
    setIsMulti(true);
    const createMultiBookingData = {
      schedule_id: +listBooking?.schedule?.id,
      seat_number: name,
      status: 1,
      depart_date: searchDateBooking,
    };
    dispatch(updateStatusBooking(createMultiBookingData));
  };
  useEffect(() => {
    if (statusResponseUpdate === Constant.DEFAULT_STATUS) {
      onCancelSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusResponseUpdate]);
  const resetTargetTicket = (value: any) => {
    setTargetTicket(value);
  };
  const onChangeFloor = (value: number | undefined) => {
    if (value && value <= 2) {
      setStatusFloor(value);
    }
  };
  useEffect(() => {
    if (listBooking?.schedule?.bus_type) {
      const tmpDataBusType = { ...listBooking?.schedule?.bus_type?.seat_map };
      setBusTypeData(tmpDataBusType);
    }
  }, [listBooking]);

  useEffect(() => {
    if (isShowAllFloor) {
      setShowAllFloor(isShowAllFloor);
    }
  }, [isShowAllFloor]);
  useEffect(() => {
    if (isShowNewBooking) {
      setShowNewBooking(isShowNewBooking);
    }
  }, [isShowNewBooking]);
  const handleChangeShowFloor: CheckboxProps["onChange"] = (e) => {
    dispatch(setIsShowAllFloor(e.target.checked));
    setIsShowAllFloor(true);
  };
  const handleChangeShowNewBooking: CheckboxProps["onChange"] = (e) => {
    dispatch(setIsShowNewBooking(e.target.checked));
  };
  useEffect(() => {
    if (listBooking && provinceId && searchDateBooking && searchDepartTime) {
      setTimeManage([
        {
          id: listBooking?.schedule?.id,
        },
      ]);
    }
  }, [listBooking, provinceId, searchDateBooking, searchDepartTime]);
  useEffect(() => {
    if (timeManage?.length) {
      let timers: NodeJS.Timeout[] = [];
      const handleUpdateStatus = async (): Promise<void> => {
        dispatch(setDetectLoading());
        dispatch(
          getBookingRenderV2({
            route_id: provinceId,
            depart_date: searchDateBooking,
            depart_time: convertTimeFormat(searchDepartTime),
            detectLoading: true,
          })
        );
      };
      const setTimer = (index: number): void => {
        const timerId: NodeJS.Timeout = setTimeout(() => {
          if (
            openCreate ||
            openModalMulti ||
            isContract ||
            openDetailScheduleBooking ||
            openModalPrint ||
            isPrintTicket
          ) {
            // Clear all timers
            timers.forEach(clearTimeout);
            return;
          }
          handleUpdateStatus();
          setTimer(index);
        }, Constant.TIMER_BOOKING);
        timers[index] = timerId;
      };
      // Start timers
      for (let i: number = 0; i < timeManage?.length; i++) {
        setTimer(i);
      }
      return (): void => {
        timers.forEach(clearTimeout);
      };
    }
  }, [
    timeManage,
    openCreate,
    openModalMulti,
    provinceId,
    searchDateBooking,
    searchDepartTime,
    dispatch,
    busTypeData,
    statusFloor,
    bookingType,
    openDetailScheduleBooking,
    openModalPrint,
    isContract,
    isPrintTicket,
  ]);
  useEffect(() => {
    if (
      openCreate ||
      openModalMulti ||
      statusResponseUpdate === Constant.DEFAULT_STATUS ||
      statusMove === Constant.DEFAULT_STATUS
    ) {
      setBusTypeData((prevMatrix: any) => {
        const newMatrix = JSON.parse(JSON.stringify(prevMatrix));
        newMatrix[`floor${statusFloor}`].forEach((row: any) => {
          row.forEach((seat: any) => {
            seat.selected = false;
          });
        });
        return newMatrix;
      });
    }
  }, [openCreate, statusFloor, openModalMulti, statusResponseUpdate,statusMove]);
  useEffect(() => {
    if (statusCheckBooking === 204 && selectedSeatName) {
      setSelectedSeatName(undefined);
      dispatch(resetCheckBookingSegment());
      dispatch(resetDestroyBooking());
      toast.error("Ghế đã đủ hành khách");
      setOpenCreate(false);
      setOpenModalMulti(false);
    } else {
      if (statusCheckBooking === Constant.DEFAULT_STATUS && selectedSeatName) {
        const createBookingData = {
          schedule_id: +listBooking?.schedule?.id,
          seat_number: selectedSeatName,
          hold_type: isMulti ? "multi" : "single",
          depart_date: searchDateBooking,
        };
        dispatch(postHoldingTicketV2(createBookingData));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    statusCheckBooking,
    listBooking,
    selectedSeatName,
    isMulti,
    searchDateBooking,
  ]);

  useEffect(() => {
    if (!(statusHolding === 200 || statusHolding === 0)) {
      setOpenCreate(false);
      setOpenModalMulti(false);
      dispatch(resetHoldingBooking());
    }
    if (statusHolding === Constant.DEFAULT_STATUS) {
      setSelectedSeatName(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusHolding]);
  useEffect(() => {
    if (
      !listDataSegmentBooking?.length &&
      statusCheckBooking === Constant.DEFAULT_STATUS
    ) {
      if (dataBooking?.ticket_code) {
        dispatch(
          destroyBooking({
            ticket_code: [dataBooking?.ticket_code],
          })
        );
      }
      dispatch(resetCheckBookingSegment());
      dispatch(resetDestroyBooking());
      toast.error("Ghế đã đủ hành khách");
      setOpenCreate(false);
      setOpenModalMulti(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDataSegmentBooking, statusCheckBooking, dataBooking]);

  useEffect(() => {
    if (statusUpdateLocation === Constant.DEFAULT_STATUS) {
      dispatch(
        setToast({
          message: CANCEL_TICKET_SUCCESS(Action.MOVE_TICKET),
          status: true,
          type: Toast.TYPE_SUCCESS,
        })
      );
      onCancelSuccess();
      dispatch(resetMoveTicket());
      dispatch(resetDataMoveTicket());
      setOpenCreate(false);
    }
  }, [dispatch, statusUpdateLocation]);

  useEffect(() => {
    if (listBooking?.schedule?.id !== dataBookingList?.schedule?.id) {
      setDataBookingList(listBooking);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listBooking]);

  useEffect(() => {
    if (statusDestroy === Constant.DEFAULT_STATUS) {
      onCancelSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusDestroy]);

  useEffect(() => {
    if (message === "Tài khoản nhà xe không đủ để xuất vé.") {
      setOpenModalAlert(true);
      if (dataBooking?.ticket_code) {
        dispatch(
          destroyBooking({
            ticket_code: [dataBooking?.ticket_code],
          })
        );
      }
      setOpenCreate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  useEffect(() => {
    if (message === "Tài khoản đại lý không đủ số dư") {
      setOpenModalAlertAgent(true);
      if (dataBooking?.ticket_code) {
        dispatch(
          destroyBooking({
            ticket_code: [dataBooking?.ticket_code],
          })
        );
      }
      setOpenCreate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);
  useEffect(() => {
    if (statusCreateUpdate === Constant.DEFAULT_STATUS) {
      dispatch(resetCheckBookingSegment());
      dispatch(resetAssistBooking());
      if (listBooking?.schedule?.id && listBookingDetail?.seat_number) {
        dispatch(
          getBookingDetailSeat({
            seat_number: listBookingDetail?.seat_number,
            is_diagram: true,
            schedule_id: listBooking?.schedule?.id,
            depart_date: searchDateBooking,
          })
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCreateUpdate]);

  useEffect(() => {
    if (statusMove === Constant.DEFAULT_STATUS) {
      dispatch(resetMoveTicket());
      dispatch(resetPostMoveBooking());
      cancelModalBookingDetail();

      if (isWaitingBooking(listBooking?.schedule)) {
        dispatch(
          getListCustomerBooking({
            schedule_id: listBooking?.schedule?.id,
            depart_date: searchDateBooking,
            status: undefined,
            is_move_waiting: isWaitingBooking(listBooking?.schedule)
              ? true
              : false,
            type: "list",
          })
        );
      }
      dispatch(
        getBookingRenderV2({
          route_id: provinceId,
          depart_date: searchDateBooking,
          depart_time: convertTimeFormat(searchDepartTime),
        })
      );
    }
  }, [
    dispatch,
    statusMove,
    provinceId,
    searchDateBooking,
    searchDepartTime,
    listBooking,
  ]);

  useEffect(() => {
    if (statusMoveTicket === Constant.DEFAULT_STATUS) {
      setOpenModalBookingDetail(false);
      setOpenModalChangeBooking(false);
      dispatch(resetMoveTicket());
      if (isWaitingBooking(listBooking?.schedule)) {
        dispatch(
          getListCustomerBooking({
            schedule_id: listBooking?.schedule?.id,
            depart_date: searchDateBooking,
            status: undefined,
            is_move_waiting: isWaitingBooking(listBooking?.schedule)
              ? true
              : false,
            type: "list",
          })
        );
      }
      dispatch(
        getBookingRenderV2({
          route_id: provinceId,
          depart_date: searchDateBooking,
          depart_time: convertTimeFormat(searchDepartTime),
        })
      );
    }
  }, [statusMoveTicket, provinceId, searchDateBooking, searchDepartTime]);

  return (
    <>
      <Loader force={loadingSend || loadingMoveTicket} />
      {dataMoveTicket?.ticket_code && isMoveTicketWaiting && (
        <div className="move-ticket-block">
          <Flex gap={8} className="block-ticket-content">
            <img src={IcMoveToast} alt="" />
            <span className="fs-16 fw-500 text-white">
              Bạn đang di chuyển vé
            </span>
          </Flex>
          <Flex gap={24} className="pr-24">
            <span className="fs-16 fw-500 text-white"> Mã vé:</span>
            <span className="fs-16 fw-500 text-white">
              {dataMoveTicket?.ticket_code}
            </span>
          </Flex>
          <Button
            className="btn-cancel"
            onClick={() => {
              dispatch(setIsMoveTicketWaiting(false));
              dispatch(resetMoveTicket());
            }}
          >
            Hủy
          </Button>
        </div>
      )}
      {listFreeSeat?.length && listAssistBooking?.length ? (
        <div className="move-ticket-block available">
          <Flex gap={20} className="block-ticket-content">
            <img src={iconAssist} alt="" />
            <span className="fs-16 fw-500 text-white">Hỗ trợ đặt vé</span>
          </Flex>
          <Flex
            gap={8}
            className={`pr-24 ${
              selectedSeatsItem?.length > 0 ? "block-assist-booking" : ""
            } `}
          >
            <span className="fs-16 fw-500 text-white">Chặng:</span>
            <span className="fs-16 fw-500 text-white">{segmentSelected} </span>
          </Flex>
          {selectedSeatsItem?.length ? (
            <Flex gap={8} className="pr-24">
              <span className="fs-16 fw-500 text-white">Đang chọn:</span>
              <span className="fs-16 fw-500 text-white">
                {`${selectedSeatsItem?.length} ghế`}{" "}
              </span>
            </Flex>
          ) : (
            ""
          )}
          <Button
            className="btn-cancel"
            onClick={() => {
              dispatch(resetAssistBooking());
            }}
          >
            Hủy
          </Button>
        </div>
      ) : (
        ""
      )}

      <div className="d-flex justify-between bus-diagram-block">
        {listBooking?.schedule?.bus_type?.seat_map?.count_floor === 2 ? (
          <div className="d-flex items-center" style={{ columnGap: "24px" }}>
            <div>
              <Button
                className={`btn-floor${
                  statusFloor === 1 && !isShowAllFloor ? " active" : ""
                }`}
                onClick={() => onChangeFloor(1)}
                disabled={isShowAllFloor}
              >
                Tầng 1
              </Button>
              <Button
                className={`btn-floor${
                  statusFloor === 2 && !isShowAllFloor ? " active" : ""
                }`}
                onClick={() => onChangeFloor(2)}
                disabled={isShowAllFloor}
              >
                Tầng 2
              </Button>
            </div>
            <Checkbox
              value={showAllFLoor}
              onChange={handleChangeShowFloor}
              className="text-blue fw-500"
              checked={isShowAllFloor ? isShowAllFloor : false}
            >
              Hiển thị 2 tầng trên 1 trang
            </Checkbox>
          </div>
        ) : (
          <div></div>
        )}
        {listBooking?.count_segment > 1 ? (
          <div className="d-flex items-center">
            <Checkbox
              value={showNewBooking}
              onChange={handleChangeShowNewBooking}
              className="text-blue fw-500"
              checked={isShowNewBooking ? isShowNewBooking : false}
            >
              Hiện tên khách mới nhất
            </Checkbox>
          </div>
        ) : (
          <></>
        )}
      </div>
      <BusDiagramBookingRender
        listBooking={listBooking}
        listBookingRender={listBookingRender}
        statusFloor={statusFloor}
        bookingData={bookingData}
        busTypeData={busTypeData}
        group={group}
        searchDateBooking={searchDateBooking}
        dateSelect={dateSelect}
        timeBooking={timeBooking}
        closeBefore={closeBefore}
        isMoveTicket={isMoveTicket}
        dataMoveTicket={dataMoveTicket}
        setBusTypeData={setBusTypeData}
        refs={refs}
        isShowAllFloor={isShowAllFloor}
        handleUnLockBooking={handleUnLockBooking}
        handleModalPrint={handleModalPrint}
        getSendBookingMail={getSendBookingMail}
        handleLockMultiBooking={handleLockMultiBooking}
        handleCreateMultiBooking={handleCreateMultiBooking}
        handleLockBooking={handleLockBooking}
        handleCreateBooking={handleCreateBooking}
        isShowNewBooking={isShowNewBooking}
        loadingBookingRender={loadingBookingRender}
        setOpenModalBookingDetail={setOpenModalBookingDetail}
        setIsDetail={setIsDetail}
        isBooking={isBooking}
        formSearch={formSearch}
        listBookingDetail={listBookingDetail}
        isDetail={isDetail}
        loading={loadingDetail}
        listBookingDetailSeat={listBookingDetailSeat}
        isMoveTicketWaiting={isMoveTicketWaiting}
        isWaitingCustomerList={false}
      />
      {listBookingRender?.wait_booking?.length ? (
        <ListCustomerNoDiagram
          listWaitingBooking={listBookingRender?.wait_booking}
          searchDateBooking={searchDateBooking}
        />
      ) : (
        ""
      )}
      <ListTicketCancel
        listBooking={listBooking}
        listBookingRender={listBookingRender}
        listBookingDetail={listBookingDetailSeat}
        refs={refs}
      />
      <ModalBooking
        okText={!isDetail ? "Đặt vé" : "Lưu"}
        modalOpen={openCreate}
        onCancel={cancelModal}
        cancelText={"Đóng"}
        onOk={handleOkModalBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        loading={loadingDetail}
        targetTime={targetTime}
        setTargetTicket={resetTargetTicket}
        isMulti={isMulti}
        isDepart={isDepart}
        isBooking={isBooking}
        isChangeTicket={isChangeTicket}
        setIsChangeTicket={setIsChangeTicket}
      />

      <ModalBookingDetail
        modalOpen={openModalBookingDetail}
        onCancel={cancelModalBookingDetail}
        cancelText={"Đóng"}
        onOk={handleOkModalBookingDetail}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        listBookingDetailSeat={listBookingDetailSeat}
        seat_number={seat_number}
        loading={loadingDetail}
        targetTime={targetTime}
        setTargetTicket={resetTargetTicket}
        isMulti={isMulti}
        isDepart={isDepart}
        isBooking={isBooking}
        isChangeTicket={isChangeTicket}
        setIsChangeTicket={setIsChangeTicket}
        searchDateBooking={searchDateBooking}
      />

      <ModalChangeBooking
        okText={!isDetail ? "Đổi vé" : "Lưu"}
        modalOpen={openModalChangeBooking}
        onCancel={cancelChangBookingModal}
        cancelText={"Đóng"}
        onOk={handleOkChangeBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        loading={loadingDetail}
        targetTime={targetTime}
        setTargetTicket={resetTargetTicket}
        searchDateBooking={searchDateBooking}
      />
      <ModalMultiBooking
        okText="Đặt vé"
        modalOpen={openModalMulti}
        onCancel={cancelModalMulti}
        cancelText={"Đóng"}
        onOk={() => setOpenModalMulti(false)}
        listBooking={listBooking}
        formSearch={formSearch}
        isMulti={isMulti}
        targetTime={targetTime}
        setTargetTicket={resetTargetTicket}
        isBooking={isBooking}
        isDepart={isDepart}
      />
      <ModalPrintTicket
        modalOpen={openModalPrint}
        onCancel={cancelModalPrint}
        onOk={() => setOpenModalPrint(false)}
        listBooking={listBooking}
        listBookingDetail={dataPrint}
        loadingDetail={loadingDetail}
      />
      <ModalAlertBalance
        modalOpen={openModalAlert}
        onCancel={cancelModalAlert}
        onOk={() => setOpenModalAlert(false)}
      />
      <ModalAlertBalanceAgent
        modalOpen={openModalAlertAgent}
        onCancel={cancelModalAlertAgent}
        onOk={() => setOpenModalAlertAgent(false)}
      />
    </>
  );
}
export default BusDiagram;
